import React, { memo, useCallback, useState } from 'react';
import { func } from 'prop-types';
import { useSelector } from 'react-redux';
import FormGroup from '@active/react-ui/FormGroup';
import FormField from '@active/react-ui/FormField';
import Form, { FormConsumer } from '@active/react-ui/Form';
import Locale from '@active/react-utils/i18n/Locale';
import Grid from '@active/react-ui/Grid';
import GridItem from '@active/react-ui/GridItem';
import Button from '@active/react-ui/Button';
import FormLabel from '@active/react-ui/FormLabel';
import Alert from '@active/react-ui/Alert';
import { withI18n } from '@active/react-utils/i18n/LocaleContext';
import CurrencyInput from '@active/react-ui/CurrencyInput';
import { useApplyTransferFeeMutation } from '../../../store/services/checkout/checkoutApi';
import pubSubInstance from '../../../shared/utils/pubSub.js';

const TransferFee = ({
  trackingCallback,
}) => {
  const [ applyTransferFee ] = useApplyTransferFeeMutation();

  const {
    entities: {
      orderInfo: {
        enableApplyTransferFee,
        currencyCode,
      },
    },
  } = useSelector(state => state.mainStateData);

  const {
    widgetNameSpace,
    locale,
  } = useSelector(state => state.propsData);

  const [ isShowServerError, setIsShowServerError ] = useState(false);
  let transferFeeForm;

  const handleSubmit = useCallback(({
    transferFeeAmount,
  }) => {
    trackingCallback && trackingCallback({ id: 'cui.transferFee.apply' });
    if (!transferFeeAmount) {
      return;
    }
    applyTransferFee({
      params: { transferFeeAmount },
    }).unwrap().then(({ repriceRequired }) => {
      if (repriceRequired) {
        transferFeeForm.setFieldValue('transferFeeAmount', '');
        setIsShowServerError(false);
        pubSubInstance.dispatch(`${widgetNameSpace}-reload`, { isReloadOffer: true });
      }
    }).catch(() => {
      setIsShowServerError(true);
    });
  }, [ trackingCallback, setIsShowServerError ]);

  if (!enableApplyTransferFee) { return null; }

  return (
    <div className="transfer-fee cui-mg-t-60">
      <h2 className="second-level-title transfer-fee__title">
        <Locale id="checkout.lib.components.text.transferFee" />
      </h2>
      <Form
        customizeLayout
        onSubmit={handleSubmit}
        className="cui-mg-t-20">
        <Grid colGap={0} rowGap={0}>
          <GridItem span={12} spanXl={8} className="transfer-fee__item">
            <div className="transfer-fee__input">
              <FormGroup name="transferFeeAmount" className="transfer-fee__input-field">
                <FormLabel hidden>
                  <Locale id="checkout.lib.components.text.transferFee" />
                </FormLabel>
                <FormField
                  autoComplete="off"
                  codeMode="symbol"
                  codePosition="prefix"
                  code={currencyCode}
                  locale={locale}
                  as={CurrencyInput}/>
              </FormGroup>
              {isShowServerError
                  && <Alert theme="inline" type="info" className="transfer-fee__error-message cui-mg-t-20">
                    <Locale id="checkout.lib.error.serviceErrorAndTry" />
                  </Alert>
              }
            </div>
            <Button submit className="transfer-fee__button cui-mg-l-20">
              <Locale id="checkout.lib.components.common.btn.apply"/>
            </Button>
          </GridItem>
        </Grid>
        <FormConsumer>
          {
            ({
              form,
            }) => {
              transferFeeForm = form;
            }
          }
        </FormConsumer>
      </Form>
    </div>
  );
};

TransferFee.propTypes = {
  trackingCallback: func,
};

export default withI18n(memo(TransferFee));
